module.exports = __webpack_public_path__ + "img/Finance.5e3f9741.svg";